import { h } from 'preact';

import PartyPill from './PartyPill';

function CandidateRow({
  partyName,
  ballotName,
  isIncumbent,
  isViewable,
  isDropout,
}) {
  let rowClass = 'candidate race__candidate-row';

  if (!isViewable) {
    rowClass += ' race__candidate-row--hidden';
  }

  return (
    <tr class={rowClass}>
      <td class="candidate__cell candidate__party">
        <PartyPill party={partyName} />
      </td>

      <th scope="row" class="candidate__cell candidate__name">
        {ballotName}{' '}
        {isIncumbent == 'Yes' && (
          <span class="pill pill--basic" title="Currently holds this seat">
            Incumbent
          </span>
        )}
        {isDropout == true && (
          <span class="dropped_out" title="Currently holds this seat">
            (dropped out)
          </span>
        )}
      </th>
    </tr>
  );
}

CandidateRow.defaultProps = {
  excludePartyInitial: false,
  isViewable: true,
  isDropout: false,
};

export default CandidateRow;
